export default "__VITE_ASSET__B2QMcgQ1__"